/**
 * Validate the input for the event location step.
 *
 * We do this via an ajax request, so this is an async function which
 * utilizes a callback.
 *
 * @name validateEventLocation
 *
 * @param {Function} callback - A callback function invoked with (err).
 */
 function validateEventLocation(callback) {
	const request = new URLSearchParams({
		search_city: this.collect().get('event_location'),
		city_id: this.collect().get('locations_cities_ID'),
		postal_code: this.collect().get('location_postal_code')
	});

	fetch('/ajax/validate-city', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: request
	})
		.then(response => {
			if (!response.ok) {
				throw new Error(`Event location network response was not ok, status code ${response.status}.`);
			}
			return response.json();
		})
		.then(response => {
			console.log('Valid event location ajax response:', response);

			if (response.status === 'success') {
				callback();
			} else {
				const publicError = new Error('Please provide an event location.');
				callback([publicError]);
			}
		})
		.catch(error => {
			console.error('Event location validation error:', error);

			const publicError = new Error('Hm, we’re having trouble validating your event location... try again?');
			callback([publicError]);
		});
}

export {
	validateEventLocation
}